module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "centerdiv"
  }, [_c('h2', [_vm._v("用户出题列表")]), _vm._v(" "), _c('prepare-problem-table-user', {
    attrs: {
      "tableData": _vm.dshProblemListUser
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18145f8f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/prepareProblemListUser.vue
// module id = 634
// module chunks = 3